export default "__VITE_ASSET__Ew77bq4K__"